<template>
    <SettingsSection
        :skeleton="true"
        :noInnerContentShadow="true"
        :maxWidth="594"
        button-label="Change Plan"
    >
        <div class="skeleton-info">
            <Skeleton :height="12" :width="508" />
            <Spacer height="0.625rem" />
            <Skeleton :height="12" :width="528" />
            <Spacer height="0.625rem" />
            <Skeleton :height="12" :width="450" />
            <Spacer height="1.25rem" />
            <Skeleton :height="12" :width="480" />
            <Spacer height="2.125rem" />
            <div class="bar-container" />
        </div>
    </SettingsSection>
</template>

<script setup>
import SettingsSection from '@/components/global/SettingsSection.vue'
import Skeleton from '@/components/util/Skeleton.vue'
import { Spacer } from '@opteo/components-next'
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.skeleton-info {
    @include container;
    @include pa-32;
}
.bar-container {
    @include container;
    min-height: 252px;
}
.bar-1 {
    @include pv-28;
    @include ph-32;
}
</style>
